export default __webpack_public_path__ + "static/6-d5bf2adfdcb77af84d5188aa372822e9.webp";